import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';

import Reporting from '../Reporting';
import Employees from '../Employees';
import Projects from '../Projects';

import headerLogo from './assets/header-logo.svg';
import Navbar from 'Components/Admin/Navbar';
import Logout from './components/Logout';

import { routes } from './routes/routes';
import { ADMIN_URL, ADMIN_URL_OLD } from './constants/constants';
import useLogOut from 'Shared/hooks/useLogOut';

import { toast } from 'react-toastify';
import AppSwitch from 'Components/AppSwitch';
import { CloseButton } from 'Components/Admin/ToastMessage';

function Admin({ profileData, match: { path } }) {
  const [logOut] = useLogOut();

  toast.configure({
    containerId: 'admin',
    position: 'bottom-right',
    autoClose: 3000,
    hideProgressBar: true,
    className: 'admin-notification',
    closeButton: <CloseButton />,
  });

  useEffect(() => {
    if (profileData && !profileData.user.isStaff) {
      toast(`You don't have Staff status`, {
        autoClose: 1800,
        type: toast.TYPE.ERROR,
        onClose: () => logOut(),
      });
    }
  }, [logOut, profileData]);

  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <div className="admin-page__header__logo">
          <a href={`/${ADMIN_URL_OLD}/`}>
            <img src={headerLogo} alt="logo header" />
            <span className="admin-page__header__logo__text">Back to old version</span>
          </a>
        </div>
        <Navbar routes={routes} />
        <Logout />
      </div>
      <div className="admin-page__main">
        <AppSwitch>
          <Redirect from={path} to={`/${ADMIN_URL}/projects/`} exact />
          <Route path={`/${ADMIN_URL}/projects/`} render={(routeProps) => <Projects {...routeProps} />} />
          <Route path={`/${ADMIN_URL}/customers`} render={() => <div>2</div>} />
          <Route path={`/${ADMIN_URL}/employees`} render={(routeProps) => <Employees {...routeProps} />} />
          <Route path={`/${ADMIN_URL}/recruitment`} render={() => <div>4</div>} />
          <Route path={`/${ADMIN_URL}/inventories`} render={() => <div>5</div>} />
          <Route path={`/${ADMIN_URL}/reporting/`} render={(routeProps) => <Reporting {...routeProps} />} />
        </AppSwitch>
      </div>
    </div>
  );
}

export default Admin;
